import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch } from "react-redux";
import { unblockPhoneNumber } from "service/actions";

const BlockNumberActions = ({ contact, updateBlockNumber }) => {
  const dispatch = useDispatch();
  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          dispatch(unblockPhoneNumber(contact.accountId, contact.phoneNumber));
        }}
        edge="end"
        aria-label="delete"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
};

export default BlockNumberActions;
